/* Willow behavior for the Judge.me product review widget.
   Configuration is read from the script tag rendered by sections/apps.liquid. */
(function willowReviewEnhancer(){
    var configScript=document.currentScript||document.querySelector('script[src*="willow-judgeme-reviews"]');
    var serverRating=Number(configScript&&configScript.dataset.rating)||0;
    var serverCount=Number(configScript&&configScript.dataset.count)||0;

    /* Judge.me publishes the star breakdown as a product metafield, and the section
       hands it over as "5:62,4:3,3:0,2:0,1:0". That is the honest source: it covers
       every review, not just the page on screen, and it needs nothing from the app's
       own markup. */
    var serverHistogram=(function(raw){
      if(!raw){return null;}
      var parsed=[];
      String(raw).replace(/["'\s]/g,'').split(',').forEach(function(pair){
        var bits=pair.split(':');
        var star=Number(bits[0]);
        var count=Number(bits[1]);
        if(bits.length===2&&star>=1&&star<=5&&count>=0){parsed.push({star:star,count:count});}
      });
      if(parsed.length!==5){return null;}
      parsed.sort(function(a,b){return b.star-a.star;});
      var sum=0;
      for(var i=0;i<5;i+=1){
        if(parsed[i].star!==5-i){return null;}
        sum+=parsed[i].count;
      }
      return sum>0?parsed:null;
    })(configScript&&configScript.dataset.histogram);

    function serverHistogramFor(total){
      if(!serverHistogram){return null;}
      var sum=0;
      serverHistogram.forEach(function(row){sum+=row.count;});
      /* The store tab counts a different set of reviews; a product breakdown printed
         beside a store total would be a different claim than the one on screen. */
      return sum===total?serverHistogram:null;
    }
    var modernRootSelector='[data-widget-container="review-widget"],.jm-review-widget,[data-judgeme-review-widget]';
    var scopedModernRootSelector=[
      '#judgeme_product_reviews[data-widget-container="review-widget"]',
      '#judgeme_product_reviews [data-widget-container="review-widget"]',
      '#judgeme_product_reviews.jm-review-widget',
      '#judgeme_product_reviews .jm-review-widget',
      '#judgeme_product_reviews[data-judgeme-review-widget]',
      '#judgeme_product_reviews [data-judgeme-review-widget]'
    ].join(',');

    function averageFrom(widget){
      if(serverRating>0){return serverRating;}
      var holder=widget.querySelector('[data-average-rating]')||widget.closest('[data-average-rating]');
      var raw=holder&&holder.getAttribute('data-average-rating');
      if(raw&&Number(raw)>0){return Number(raw);}
      var stars=widget.querySelector('.jdgm-rev-widg__summary-stars');
      if(stars){
        raw=stars.getAttribute('data-score')||stars.getAttribute('aria-label')||stars.getAttribute('title')||'';
        var match=String(raw).match(/([0-5](?:\.\d+)?)/);
        if(match&&Number(match[1])>0){return Number(match[1]);}
      }
      return 0;
    }

    function countFrom(widget){
      if(serverCount>0){return serverCount;}
      var summary=widget.querySelector('.jdgm-rev-widg__summary-text');
      var match=summary&&String(summary.textContent||'').replace(/,/g,'').match(/(\d+)\s+reviews?/i);
      return match?Number(match[1]):0;
    }

    function setExpanded(widget,expanded){
      widget.classList.toggle('willow-reviews-expanded',expanded);
      var toggle=widget.querySelector('.willow-review-toggle');
      if(toggle){
        toggle.setAttribute('aria-expanded',expanded?'true':'false');
        var label=toggle.querySelector('span');
        if(label){label.textContent=expanded?'Show fewer reviews':'Show more reviews';}
      }
      var viewAll=widget.querySelector('.willow-review-view-all');
      if(viewAll){viewAll.setAttribute('aria-expanded',expanded?'true':'false');}
    }

    function enhance(widget){
      if(!widget){return;}
      var list=widget.querySelector('.jdgm-rev-widg__reviews');
      var header=widget.querySelector('.jdgm-rev-widg__header');
      if(!list||!header){return;}

      var rating=averageFrom(widget);
      var score=header.querySelector('.willow-review-score');
      if(rating>0){
        if(!score){
          score=document.createElement('span');
          score.className='willow-review-score';
          var title=header.querySelector('.jdgm-rev-widg__title');
          if(title){title.insertAdjacentElement('afterend',score);}
          else{header.insertBefore(score,header.firstChild);}
        }
        var scoreText=rating.toFixed(1);
        if(score.textContent!==scoreText){score.textContent=scoreText;}
      }else if(score){score.remove();}

      var count=countFrom(widget);
      var viewAll=widget.querySelector('.willow-review-view-all');
      if(!viewAll){
        viewAll=document.createElement('button');
        viewAll.type='button';
        viewAll.className='willow-review-view-all';
        viewAll.setAttribute('aria-expanded','false');
        viewAll.addEventListener('click',function(){setExpanded(widget,true);});
        widget.appendChild(viewAll);
      }
      var viewLabel=count>0?'View all '+count+' review'+(count===1?'':'s'):'View reviews';
      if(viewAll.getAttribute('data-label')!==viewLabel){
        viewAll.setAttribute('data-label',viewLabel);
        viewAll.innerHTML='<b style="font:inherit">'+viewLabel+'</b><span aria-hidden="true">→</span>';
      }

      var reviews=Array.prototype.filter.call(list.children,function(node){
        return node.classList&&node.classList.contains('jdgm-rev');
      });
      reviews.forEach(function(review,index){
        review.classList.toggle('willow-review-extra',index>=3);
      });

      var button=widget.querySelector('.willow-review-toggle');
      if(reviews.length<=3){
        if(button){button.remove();}
        widget.classList.remove('willow-reviews-expanded');
        return;
      }

      if(!button){
        button=document.createElement('button');
        button.type='button';
        button.className='willow-review-toggle';
        button.setAttribute('aria-expanded','false');
        button.innerHTML='<span>Show more reviews</span><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 6 8 10.5 12.5 6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        button.addEventListener('click',function(){
          setExpanded(widget,!widget.classList.contains('willow-reviews-expanded'));
        });
        (widget.querySelector('.jdgm-rev-widg__body')||widget).appendChild(button);
      }
    }

    function modernCountsFrom(widget){
      var text=String(widget.textContent||'').replace(/,/g,'');
      var product=text.match(/product\s+reviews?\s*\((\d+)\)/i);
      var store=text.match(/store\s+reviews?\s*\((\d+)\)/i);
      return {
        product:product?Number(product[1]):0,
        store:store?Number(store[1]):0
      };
    }

    function modernTabFor(widget,kind){
      var tabs=widget.querySelectorAll('[role="tab"]');
      for(var i=0;i<tabs.length;i+=1){
        var label=String(tabs[i].textContent||'').toLowerCase();
        if(label.indexOf(kind+' review')>=0){return tabs[i];}
      }
      return null;
    }

    function modernActiveCount(widget,counts){
      var active=widget.querySelector('[role="tab"][aria-selected="true"]');
      var label=String(active&&active.textContent||'').toLowerCase();
      if(label.indexOf('store review')>=0){return counts.store;}
      if(label.indexOf('product review')>=0){return counts.product;}
      return counts.product>0?counts.product:counts.store;
    }

    function defaultModernTab(widget,counts){
      if(widget.__willowDefaultedReviewTab||counts.product>0||counts.store<=0){return false;}
      var storeTab=modernTabFor(widget,'store');
      if(!storeTab){return false;}
      widget.__willowDefaultedReviewTab=true;
      if(storeTab.getAttribute('aria-selected')==='true'){return false;}
      requestAnimationFrame(function(){
        if(storeTab.isConnected){storeTab.click();}
      });
      return true;
    }

    function modernAverageFrom(widget){
      if(serverRating>0){return serverRating;}
      var nodes=widget.querySelectorAll('[data-average-rating],[data-score],.jm-average-rating-display');
      for(var i=0;i<nodes.length;i+=1){
        var raw=nodes[i].getAttribute('data-average-rating')||
          nodes[i].getAttribute('data-score')||
          nodes[i].getAttribute('aria-label')||
          nodes[i].textContent||'';
        var match=String(raw).replace(',','.').match(/([0-5](?:\.\d+)?)/);
        if(match&&Number(match[1])>0){return Number(match[1]);}
      }
      return 0;
    }

    /* Judge.me draws its own star breakdown and we hide it, because it arrives with the
       app's own type and bar colours. Read its five rows instead and redraw them in our
       own column — and only when they parse cleanly and add up to the count we already
       show, so a markup change on their side leaves the block exactly as it is today. */
    function modernHistogramFrom(widget,total){
      var host=widget.querySelector('.jm-histogram,.jm-review-widget-header__star-rating-histogram,[class*="histogram"]');
      if(!host){return null;}
      var rows=Array.prototype.filter.call(host.children,function(node){return node.nodeType===1;});
      if(rows.length===1){
        rows=Array.prototype.filter.call(rows[0].children,function(node){return node.nodeType===1;});
      }
      if(rows.length!==5){return null;}
      var parsed=[];
      for(var i=0;i<5;i+=1){
        var numbers=String(rows[i].textContent||'').replace(/,/g,'').match(/\d+/g);
        if(!numbers){return null;}
        var star=numbers.length>1?Number(numbers[0]):5-i;
        var count=Number(numbers[numbers.length-1]);
        if(!(star>=1&&star<=5)||!(count>=0)){return null;}
        parsed.push({star:star,count:count});
      }
      parsed.sort(function(a,b){return b.star-a.star;});
      var sum=0;
      for(var j=0;j<5;j+=1){
        if(parsed[j].star!==5-j){return null;}
        sum+=parsed[j].count;
      }
      if(sum<=0||(total>0&&sum!==total)){return null;}
      return parsed;
    }

    /* Judge.me does not always render a histogram to read. When every review it has is
       on screen — the count matches the cards — the breakdown is simply the cards
       themselves, counted by their own stars. Anything less than all of them would
       describe one page of reviews as if it were the whole product, so we bail. */
    function starsOf(review){
      var group=review.querySelector('.jm-star-rating,[class*="star-rating"]');
      var icons=group?group.querySelectorAll('.jm-star-rating__font-icon'):[];
      if(icons.length!==5){return 0;}
      var score=0;
      for(var i=0;i<5;i+=1){
        var type=icons[i].getAttribute('data-willow-star');
        if(type==='filled'){score+=1;}
        else if(type==='half'){score+=.5;}
      }
      return Math.round(score);
    }

    function distributionFromCards(reviews,total){
      if(total<3||reviews.length!==total){return null;}
      var tally=[0,0,0,0,0];
      for(var i=0;i<reviews.length;i+=1){
        var star=starsOf(reviews[i]);
        if(!(star>=1&&star<=5)){return null;}
        tally[5-star]+=1;
      }
      return tally.map(function(count,index){
        return {star:5-index,count:count};
      });
    }

    function histogramMarkup(distribution){
      if(!distribution){return '';}
      var sum=0;
      distribution.forEach(function(row){sum+=row.count;});
      if(sum<=0){return '';}
      return '<div class="willow-jm-hist">'+distribution.map(function(row){
        return '<div class="willow-jm-hist__row" aria-label="'+row.count+' review'+(row.count===1?'':'s')+' with '+row.star+' star'+(row.star===1?'':'s')+'">'+
          '<span class="willow-jm-hist__label">'+row.star+'<i aria-hidden="true">★</i></span>'+
          '<span class="willow-jm-hist__track"><span class="willow-jm-hist__fill" style="width:'+(row.count/sum*100).toFixed(1)+'%"></span></span>'+
          '<span class="willow-jm-hist__count">'+row.count+'</span>'+
        '</div>';
      }).join('')+'</div>';
    }

    /* The heading and the invitation to write share one row above everything else, so
       the block opens the way the rest of the page does — a title, not a control. */
    function ensureModernHead(widget){
      var head=widget.querySelector('.willow-jm-head');
      if(!head){
        head=document.createElement('div');
        head.className='willow-jm-head';
        head.innerHTML=
          '<div class="willow-jm-head__text">'+
            '<h2 class="willow-jm-head__title">Customer reviews</h2>'+
            '<p class="willow-jm-head__note" hidden></p>'+
          '</div>';
        widget.insertBefore(head,widget.firstChild);
      }else if(widget.firstChild!==head){
        widget.insertBefore(head,widget.firstChild);
      }

      /* Judge.me can re-render its action row. Take whichever copy it just made and
         drop the one we had moved, so a re-render never leaves two Write a review
         buttons on the page. */
      var groups=widget.querySelectorAll('.jm-action-buttons');
      for(var i=0;i<groups.length;i+=1){
        if(groups[i].parentElement===head){continue;}
        var stale=head.querySelector('.jm-action-buttons');
        if(stale&&stale!==groups[i]){stale.remove();}
        head.appendChild(groups[i]);
      }

      /* Judge.me groups a series, so a card can be about another size or finish. Say so
         — but only when a card actually names a different model. */
      var note=head.querySelector('.willow-jm-head__note');
      if(note){
        var crossModel=!!widget.querySelector('.jm-product-variant-card');
        note.textContent='Reviews across this line — every card names the model it was written for.';
        note.hidden=!crossModel;
      }
      return head;
    }

    function renderModernSummary(widget,count,rating,distribution,storeCount){
      var head=widget.querySelector('.willow-jm-head');
      var summary=widget.querySelector('.willow-jm-summary');
      if(!summary){
        summary=document.createElement('div');
        summary.className='willow-jm-summary';
      }
      if(head&&summary.previousElementSibling!==head){head.insertAdjacentElement('afterend',summary);}
      else if(!head&&!summary.parentElement){widget.insertBefore(summary,widget.firstChild);}

      var safeRating=rating>0?Math.min(5,rating):0;
      var bars=distribution?distribution.map(function(row){return row.count;}).join('-'):'';
      var signature=[count,safeRating.toFixed(2),bars,storeCount||0].join('|');
      if(summary.getAttribute('data-summary')===signature){return;}
      summary.setAttribute('data-summary',signature);
      summary.setAttribute('data-bars',distribution?'1':'0');

      var tally=count>0?count+' review'+(count===1?'':'s'):'Be the first to review';
      if(count>0&&storeCount>0&&storeCount!==count){tally+=' · '+storeCount+' across the store';}

      summary.innerHTML=
        '<div class="willow-jm-summary__figure">'+
          (safeRating>0?'<div class="willow-jm-summary__score">'+safeRating.toFixed(1)+'</div>':'')+
          (safeRating>0?'<div class="willow-jm-summary__stars" aria-label="'+safeRating.toFixed(1)+' out of 5 stars" style="--willow-star-fill:'+(safeRating/5*100).toFixed(1)+'%">★★★★★</div>':'')+
          '<div class="willow-jm-summary__count">'+tally+'</div>'+
        '</div>'+
        histogramMarkup(distribution);
    }

    function normalizeCopy(value){
      return String(value||'').replace(/\s+/g,' ').replace(/[“”"'’.,!:;–—-]+/g,'').trim().toLowerCase();
    }

    /* Reviewers routinely retype their title as the first line of the review. In a card
       this narrow that reads as a stutter, so the repeated half is hidden — never
       rewritten, so Judge.me keeps owning the text it renders. */
    function dedupeModernCopy(review){
      var title=review.querySelector('.jm-review-content__title,[class*="review-content__title"]');
      var body=review.querySelector('.jm-review-content__body,.jm-review__body,[class*="review-content__body"]');
      if(title){title.classList.remove('willow-jm-dupe');}
      if(body){body.classList.remove('willow-jm-dupe');}
      if(!title||!body){return;}
      var head=normalizeCopy(title.textContent);
      var text=normalizeCopy(body.textContent);
      if(!head||!text){return;}
      /* Word for word, the body says nothing the title did not — drop it at any length.
         A body that merely opens with the title needs a longer title to be sure it is a
         repeat and not a short word the review happens to start with. */
      if(text===head){body.classList.add('willow-jm-dupe');}
      else if(head.length>=12&&text.indexOf(head)===0){title.classList.add('willow-jm-dupe');}
    }

    function normalizeModernStars(widget){
      Array.prototype.forEach.call(widget.querySelectorAll('.jm-star-rating__font-icon'),function(star){
        var glyph=String(star.textContent||'').charCodeAt(0);
        var type=glyph===0xE001?'empty':(glyph===0xE002?'half':'filled');
        if(star.getAttribute('data-willow-star')!==type){
          star.setAttribute('data-willow-star',type);
        }
      });
    }

    /* One row that slides, so the block stays short no matter how many reviews it
       carries. Trackpads and touch scroll it natively; a mouse gets the arrows. */
    function ensureModernCarousel(widget,track,reviews){
      var controls=widget.querySelector('.willow-jm-carousel-controls');
      if(!track||!reviews.length){
        if(controls){controls.remove();}
        return;
      }
      if(reviews.length>1&&!controls){
        controls=document.createElement('div');
        controls.className='willow-jm-carousel-controls';
        controls.innerHTML=
          '<button type="button" class="willow-jm-carousel-button" data-direction="-1" aria-label="Previous reviews"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.5 4.5 7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'+
          '<button type="button" class="willow-jm-carousel-button" data-direction="1" aria-label="Next reviews"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7.5 4.5 5.5 5.5-5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
        widget.appendChild(controls);
      }else if(reviews.length<=1&&controls){
        controls.remove();
        controls=null;
      }

      var update=function(){
        if(!controls||!controls.isConnected){return;}
        var max=Math.max(0,track.scrollWidth-track.clientWidth);
        var previous=controls.querySelector('[data-direction="-1"]');
        var next=controls.querySelector('[data-direction="1"]');
        if(previous){previous.disabled=track.scrollLeft<=3;}
        if(next){next.disabled=track.scrollLeft>=max-3;}
        var widgetRect=widget.getBoundingClientRect();
        var trackRect=track.getBoundingClientRect();
        widget.style.setProperty('--willow-jm-grid-mid',Math.round(trackRect.top-widgetRect.top+trackRect.height/2)+'px');
      };

      if(controls&&!controls.__willowCarouselControls){
        controls.__willowCarouselControls=true;
        controls.addEventListener('click',function(event){
          var control=event.target.closest('[data-direction]');
          if(!control||control.disabled){return;}
          var card=track.querySelector('.willow-jm-card');
          var gap=parseFloat(getComputedStyle(track).gap)||14;
          var step=card?card.getBoundingClientRect().width+gap:track.clientWidth*.9;
          track.scrollBy({left:step*Number(control.getAttribute('data-direction')),behavior:'smooth'});
        });
      }

      if(!track.__willowCarouselTrack){
        track.__willowCarouselTrack=true;
        var drag={active:false,moved:false,x:0,left:0,pointer:null};
        track.addEventListener('scroll',update,{passive:true});
        track.addEventListener('pointerdown',function(event){
          if(event.pointerType!=='mouse'||event.button!==0){return;}
          if(event.target.closest('a,button,input,textarea,select,label,[role="button"],[contenteditable="true"]')){return;}
          drag.active=true;
          drag.moved=false;
          drag.x=event.clientX;
          drag.left=track.scrollLeft;
          drag.pointer=event.pointerId;
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        });
        track.addEventListener('pointermove',function(event){
          if(!drag.active||event.pointerId!==drag.pointer){return;}
          var delta=event.clientX-drag.x;
          if(Math.abs(delta)>5){drag.moved=true;}
          if(drag.moved){track.scrollLeft=drag.left-delta;}
        });
        var finish=function(event){
          if(!drag.active||event.pointerId!==drag.pointer){return;}
          drag.active=false;
          track.classList.remove('is-dragging');
          if(drag.moved){
            track.__willowSuppressClick=true;
            setTimeout(function(){track.__willowSuppressClick=false;},0);
          }
          update();
        };
        track.addEventListener('pointerup',finish);
        track.addEventListener('pointercancel',finish);
        track.addEventListener('click',function(event){
          if(track.__willowSuppressClick){event.preventDefault();event.stopPropagation();}
        },true);
        window.addEventListener('resize',update,{passive:true});
        if('ResizeObserver' in window){
          track.__willowCarouselResizeObserver=new ResizeObserver(update);
          track.__willowCarouselResizeObserver.observe(track);
        }
      }

      requestAnimationFrame(update);
      setTimeout(update,250);
      setTimeout(update,900);
    }

    /* The widget sits inside whatever wrappers the Judge.me app block renders, and on a
       wide screen one of those — not our own shell — is what holds the block in: the
       reviews stopped well short of the trust strip and the footer beside them. Walk up
       to the section's own .page-width and drop any max-width that is narrower than the
       room the parent actually has, so the block lines up with the rest of the page. */
    function widenModernShell(widget){
      if(!widget||window.innerWidth<1400){return;}
      var node=widget.parentElement;
      var guard=0;
      while(node&&node!==document.body&&guard<8){
        guard+=1;
        if(node.classList&&(node.classList.contains('page-width')||node.classList.contains('section'))){return;}
        var room=node.parentElement?node.parentElement.clientWidth:0;
        var cap=parseFloat(getComputedStyle(node).maxWidth);
        if(cap&&room&&cap<room){
          node.style.maxWidth='none';
          node.style.width='100%';
        }
        node=node.parentElement;
      }
    }

    function enhanceModern(widget){
      if(!widget){return;}
      widget.classList.add('willow-jm-enhanced');
      widenModernShell(widget);
      normalizeModernStars(widget);
      ensureModernHead(widget);

      var reviews=Array.prototype.slice.call(widget.querySelectorAll('.jm-review-item,.jm-review')).filter(function(review){
        return !review.closest('form')&&review.closest(modernRootSelector)===widget;
      });
      var unique=[];
      reviews.forEach(function(review){
        if(unique.indexOf(review)<0){unique.push(review);}
      });
      reviews=unique;

      /* Every review Judge.me put on this page belongs in the grid: the rail used to
         hide all but the first few, and those classes are still styled by an id-level
         rule, so they come off explicitly rather than just going unset. */
      reviews.forEach(function(review){
        review.classList.add('willow-jm-card');
        review.classList.remove('willow-review-extra');
        review.classList.remove('willow-review-mobile-extra');
        dedupeModernCopy(review);
      });

      var parent=null;
      if(reviews.length){
        parent=reviews[0].parentElement;
        var sameParent=reviews.every(function(review){return review.parentElement===parent;});
        if(sameParent&&parent){parent.classList.add('willow-jm-grid');}
      }

      var counts=modernCountsFrom(widget);
      if(defaultModernTab(widget,counts)){return;}
      var count=modernActiveCount(widget,counts);
      var rating=modernAverageFrom(widget);
      var summary=widget.querySelector('.willow-jm-summary');
      if(count>0){
        widget.hidden=false;
        widget.removeAttribute('aria-hidden');
        var distribution=serverHistogramFor(count)||modernHistogramFrom(widget,count)||distributionFromCards(reviews,count);
        renderModernSummary(widget,count,rating,distribution,counts.store);
      }else if(summary){
        summary.remove();
      }

      var tabs=widget.querySelectorAll('[role="tab"]');
      if(tabs.length&&counts.product===0&&counts.store===0){
        widget.hidden=true;
        widget.setAttribute('aria-hidden','true');
      }else{
        widget.hidden=false;
        widget.removeAttribute('aria-hidden');
      }

      var viewAll=widget.querySelector('.willow-review-view-all');
      if(viewAll){viewAll.remove();}

      var button=widget.querySelector('.willow-review-toggle');
      if(button){button.remove();}
      widget.classList.remove('willow-reviews-expanded');

      ensureModernCarousel(widget,count>0?parent:null,count>0?reviews:[]);
    }

    function enhanceWidget(widget){
      if(widget.matches(modernRootSelector)){enhanceModern(widget);}
      else{enhance(widget);}
    }

    function connect(){
      var modernWidgets=Array.prototype.slice.call(document.querySelectorAll(scopedModernRootSelector));
      modernWidgets=modernWidgets.filter(function(widget,index,all){
        return all.indexOf(widget)===index&&!all.some(function(other){
          return other!==widget&&widget.contains(other);
        });
      });
      var legacyWidgets=Array.prototype.slice.call(document.querySelectorAll(
        '#judgeme_product_reviews .jdgm-rev-widg, #judgeme_product_reviews.jdgm-rev-widg'
      ));
      var widgets=modernWidgets.concat(legacyWidgets);
      if(!widgets.length){return false;}
      widgets.forEach(function(widget){
        enhanceWidget(widget);
        if(!widget.__willowReviewObserver){
          var queued=false;
          var reviewObserver=new MutationObserver(function(){
            if(queued){return;}
            queued=true;
            requestAnimationFrame(function(){
              queued=false;
              reviewObserver.disconnect();
              enhanceWidget(widget);
              reviewObserver.observe(widget,{childList:true,subtree:true});
            });
          });
          widget.__willowReviewObserver=reviewObserver;
          reviewObserver.observe(widget,{childList:true,subtree:true});
        }
      });
      return true;
    }

    function start(){
      if(connect()){return;}
      var tries=0;
      var timer=setInterval(function(){
        tries+=1;
        if(connect()||tries>80){clearInterval(timer);}
      },125);
    }

    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',start,{once:true});
    }else{start();}
    document.addEventListener('shopify:section:load',start);
  })();
